import { useEffect, useState } from "react";
import "./CustomCurrentRedChart.css";
import Chart from "react-apexcharts";

const CustomCurrentRedChart = (props) => {
    const [chartconfig2, setChartconfig2] = useState();
    useEffect(() => {
        setChartconfig2({
            options: {
                chart: {
                    id: "basic-bar"
                },
                xaxis: {
                    categories: props.time,
                    title: {
                        text: "Time"
                    }
                },
                yaxis: {
                    title: {
                        text: "Current"
                    }
                },
                title:{
                    text:"Current wrt to Time",
                    align:"center"
                },
                legend:{
                    show:true
                },
                dataLabels:{
                    enabled:true
                }
            },
            series: [
                {
                    name: "series-1",
                    data: props.value
                }
            ]
        });
        
    }, [props]);
    return (
        <div>
            {chartconfig2 ? <Chart
                options={chartconfig2.options}
                series={chartconfig2.series}
                type="line"
                width="500"
            />:null}
        </div>
    );
}

export default CustomCurrentRedChart;